import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from 'store'
import { actions as reportingBenchmarkActions } from 'store/reporting/benchmark'

export function useBenchmarkExists(id: string | undefined) {
  const dispatch = useAppDispatch()

  const status = useSelector((state: RootState) => state.reportingBenchmark.status)

  useEffect(() => {
    if (!id) return
    dispatch(reportingBenchmarkActions.fetchBenchmarkStatus(id))
  }, [id, dispatch])

  const exists = status //&& status !== 'not_found'

  return { exists, status }
}
